// Shared grade utility — used across all SimForge pages
// Letters only, no raw numbers shown to users (crypto compliance)

export function numberToGrade(value: number | undefined | null): string {
  if (value === undefined || value === null) return '-';
  if (value >= 90) return 'S';
  if (value >= 85) return 'A+';
  if (value >= 80) return 'A';
  if (value >= 75) return 'A-';
  if (value >= 70) return 'B+';
  if (value >= 65) return 'B';
  if (value >= 60) return 'B-';
  if (value >= 55) return 'C+';
  if (value >= 50) return 'C';
  if (value >= 45) return 'C-';
  if (value >= 40) return 'D+';
  if (value >= 35) return 'D';
  if (value >= 30) return 'D-';
  return 'F';
}

export function getGradeColor(grade: string): string {
  if (grade.startsWith('S')) return '#00d4aa';
  if (grade.startsWith('A')) return '#3b82f6';
  if (grade.startsWith('B')) return '#f59e0b';
  if (grade.startsWith('C')) return '#a78bfa';
  if (grade.startsWith('D')) return '#94a3b8';
  return '#6b7280';
}

export function getOverallColor(overall: number): string {
  return getGradeColor(numberToGrade(overall));
}

// Keep numeric color for internal/bar rendering only (not user-visible)
export function getAttrColor(val: number): string {
  return getGradeColor(numberToGrade(val));
}
